import _Summary from './Summary';

import _Profile from './Profile';

export const DesignerSummary = _Summary;
export const DesignerProfile = _Profile;
